const minLength = (min: any) => {
  const error = {
    name: "minLength"
  };
  return (input: any) => (input.length < min ? error : null);
};

const email = () => {
  const re = /\S+@\S+\.\S+/;
  const error = {
    name: "email"
  };
  return (input: any) => (!re.test(input) ? error : null);
};

const required = () => {
  return (input: any) => {
    const error = {
      name: "required"
    };
    return !input ? error : null;
  };
};

const confirmPassword = (valuePassword: any) => {
  return (input: any) => {
    const error = {
      name: "confirmPassword"
    };
    return input !== valuePassword.value ? error : null;
  };
};

const minPlayer = (min: number) => {
  const error = {
    name: "minPlayer",
    param: min
  };
  return (input: number) => (input < min ? error : null);
};

const maxPlayer = (max: number) => {
  const error = {
    name: "maxPlayer",
    param: max
  };
  return (input: number) => (input > max ? error : null);
};

export { minLength, email, required, confirmPassword, minPlayer, maxPlayer };
